<template>
    <div>
      <div class="row">

        <div class="col-12">
        <p class="pl-2 pt-2 text-lg font-semibold underline">Keahlian / Skill</p>
        <br>
      </div>
      <div class="col-12">
        <div class="row" v-if="subskill.length>0">

          <div class="col-6" v-for="(item, index) in subskill" :key="index+'subskill'">
            <p
              style="font-size:10px;"
              class="p-2  text-xs font-bold animate__animated animate__flipInX "
            >{{item.title}}</p>
            <div
              style="width: 100%;"
              :style="`background-color:#ddd;`"
              class="rounded-lg shadow-lg animate__animated animate__flipInX "
            >
              <div class="rounded-l-lg pt-1 pr-2" :style="`width:${item.persen}%;background:${item.warna};`" style="text-align:right;font-size:12px;">{{item.persen}}%</div>
            </div>
          </div>
          <div class="col-12">
            <p class="font-semibold p-3 underline mt-2">Main Skill/Keahlian</p>
          </div>
          <div class="col-12 " v-for="(item, index) in skill" :key="index+'skill'">
            <p
              style="font-size:10px;"
              class="p-2  text-xs font-bold animate__animated animate__flipInX "
            >{{item.title}}</p>
            <div
              style="width: 100%;"
              :style="`background-color:#ddd;`"
              class="rounded-lg shadow-lg animate__animated animate__flipInX "
            >
              <div class="rounded-l-lg   pt-1 pr-2" :style="`width:${item.persen}%;background:${item.warna};`" style="text-align:right;font-size:12px;">{{item.persen}}%</div>
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
      </div>
    </div>
</template>
<script>
import autophp from '@/plugins/autophp'
let sdb = new autophp()
let urlnya='https://gis.officialapp.my.id'
export default{
    data(){
        return{
            skill:[],
            subskill:[],
        }
    },
    mounted () {
        sdb.collection("app_portofolio_skill",false,urlnya).doc().select(`select * from app_portofolio_skill  where iduser='${this.$store.state.id}'`).then(res => {
            this.skill=res;
            this.$forceUpdate();
        });
        
        sdb.collection("app_portofolio_subskill",false,urlnya).doc().select(`select * from app_portofolio_subskill  where iduser='${this.$store.state.id}'`).then(res => {
            this.subskill=res;
            this.$forceUpdate();
        });
  },
}
</script>